/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 */

import { basePath, isAnalyticsEnabled } from '../../constants/commonConstants';
import { makeRequest, sendAnalyticsEvent } from '../../helpers';

export const postMotorQuote = async (motorQuoteData, props = {}) => {
  const quoteRequest = await makeRequest({
    method: 'POST',
    url: `${basePath}/motor/motor_quotes`,
    payload: motorQuoteData,
    history: props.history
  });

  if (isAnalyticsEnabled) {
    sendAnalyticsEvent(quoteRequest, 'insuranceEvent', 'Car');
  }
  return quoteRequest;
};
